import { render, staticRenderFns } from "./EditPolicyExemptions.vue?vue&type=template&id=116d8c12"
import script from "./EditPolicyExemptions.vue?vue&type=script&lang=ts"
export * from "./EditPolicyExemptions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/components/_locales/Organs.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2Forgans%2FEditPolicyExemptions.vue&external"
if (typeof block0 === 'function') block0(component)
import block1 from "@/views/_locales/organs.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2Forgans%2FEditPolicyExemptions.vue&external"
if (typeof block1 === 'function') block1(component)
import block2 from "@/components/organs/shared/_locales/PolicyExemptions.json?vue&type=custom&index=2&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2Forgans%2FEditPolicyExemptions.vue&external"
if (typeof block2 === 'function') block2(component)

export default component.exports